import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['selectAll', 'row']

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.rowTargets.forEach(cb => { cb.checked = checked })
  }

  syncSelectAll() {
    const total = this.rowTargets.length
    if (total === 0) return
    const checkedCount = this.rowTargets.filter(cb => cb.checked).length
    this.selectAllTarget.indeterminate = checkedCount > 0 && checkedCount < total
    this.selectAllTarget.checked = checkedCount === total
  }
}
